import { render } from "./PlayerHeaderBox.vue?vue&type=template&id=5d4194b0"
import script from "./PlayerHeaderBox.vue?vue&type=script&lang=js"
export * from "./PlayerHeaderBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__